export default __webpack_public_path__ + "static/media/thankyou.093b3105.jpg";